export const CreateVoucherErrorFrequency = {
  daily: $localize`Daily`,
  monthly: $localize`Monthly`,
  yearly: $localize`Yearly`,
};
